import { render, staticRenderFns } from "./lookup.vue?vue&type=template&id=50b826a8&"
import script from "./lookup.vue?vue&type=script&lang=js&"
export * from "./lookup.vue?vue&type=script&lang=js&"
import style0 from "./lookup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/alpheios-core/alpheios-core/packages/components/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50b826a8')) {
      api.createRecord('50b826a8', component.options)
    } else {
      api.reload('50b826a8', component.options)
    }
    module.hot.accept("./lookup.vue?vue&type=template&id=50b826a8&", function () {
      api.rerender('50b826a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "vue/components/lookup.vue"
export default component.exports